import React, { useCallback, useEffect, useRef } from 'react';
import { isEmpty as _isEmpty, map as _map, orderBy as _orderBy } from 'lodash-es';
import { NavLink } from 'react-router-dom';
import { isMobile } from 'react-device-detect';
import { useDispatch, useSelector } from 'react-redux';
import SummeryLoader from 'components/SummeryLoader/SummeryLoader';
import { getMenuPath } from 'utilities/utilities_exports';
import './HeaderMenuBar.scss';
import { useLocation, useNavigate } from 'react-router-dom';
import { WorkSpaceConstants } from 'redux/WorkSpace/WorkSpace.constants';

const HeaderMenuBar = props => {
  const { data, isChannelConnected } = props;
  const accountDetails = useSelector(state => state?.User?.accountDetails);
  const selectedIntegrationGoals = accountDetails?.selectedIntegrationGoals || [];
  const navigationMenus = data?.navigationMenus;
  const availableMenus = navigationMenus?.availableMenus;
  let location = useLocation();
  const pathSegments = location.pathname.split('/').filter(segment => segment);
  const prevLocation = useRef(null);
  const WorkSpaceState = useSelector(state => state.WorkSpace);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const hasWriteAccess = useSelector(state => state?.Account?.hasWriteAccess);

  useEffect(() => {
    prevLocation.current = location.pathname;
  }, [location]);

const updateDashboardAndNavigate = (dashboardId) => async dispatch => {
  try {
    await dispatch({
      type: WorkSpaceConstants.UPDATE_SELECTED_DASHBOARD,
      payload: dashboardId
    });

    return true;
  } catch (error) {
    console.error('Error updating dashboard:', error);
    return false;
  }
};

const handleNavLinkClick = useCallback(() => {
  const hasEmptyVisualizationSet = _isEmpty(WorkSpaceState?.selectedDashboardConfig?.visualisation_set);

  if (hasEmptyVisualizationSet) {
    const firstDashboard = WorkSpaceState?.activeDashboards?.[0];
    
    if (firstDashboard?.dashboardId) {
      dispatch(updateDashboardAndNavigate(firstDashboard.dashboardId, firstDashboard.code))
        .then(success => {
          if (success) {
            navigate(
              `/analyze/workspace?id=${firstDashboard.dashboardId}&tab=${firstDashboard.code}&redirected=chart-builder`
            );
          }
        });
    }
  }
}, [location.pathname, WorkSpaceState, dispatch, navigate]);

  const redirectTo = menuPath => {
    window.location.href = window.location.origin + menuPath;
  };

  // * Check at least one sales channel or Ads channel connected or not

  // --- function to render header menu item
  const getHeaderMenuItem = menuItem => {
    if (menuItem?.id === 'nav_execute' && !hasWriteAccess) {
      return;
    }
    let path = location?.pathname?.split('/').filter(e => !_isEmpty(e))?.[0] || '';

    if (_isEmpty(menuItem)) return null;
    if (!availableMenus.includes(menuItem?.id) && !accountDetails?.isBillPlanEnabled) return null;
    let menuPath = getMenuPath(
      menuItem,
      availableMenus,
      accountDetails?.isBillPlanEnabled,
      accountDetails?.isNewMenuStructureEnabled
    );

    if (!isChannelConnected && _isEmpty(selectedIntegrationGoals)) {
      if (menuPath === '/connect/') {
        if (
          pathSegments?.includes('analyze') ||
          pathSegments?.includes('predict') ||
          pathSegments?.includes('executor') ||
          pathSegments?.includes('extract')
        ) {
          //  if channel is not connected then we are  redirect to connect page
          redirectTo(`${menuPath}`);
        }
        return (
          <NavLink
            // activeClassName='active'
            className={({ isActive }) => (isActive ? "headerMenu_item active" : "headerMenu_item")}
            qa-data={menuItem?.label}
            to={menuPath}
            // className={`headerMenu_item`}
            
            headerMenu_item
            key={menuItem?.id}
          >
            {menuItem?.label}
          </NavLink>
        );
      }
    } else {
      if (!isChannelConnected && _isEmpty(path)) {
        //  if channel is not connected then we are  redirect to connect page
        redirectTo(`/connect/`);
      }
      if (menuItem?.isExternalRoute) {
        return (
          <NavLink
            to={`${menuPath}`}
            className={`headerMenu_item external ${path === 'executor' || path === 'execute' ? 'active' : ''}`}
            key={menuItem?.id}
            onClick={() => {
              if (path === 'execute') {
                redirectTo(`${menuPath}`);
              }
            }}
            qa-data={menuItem?.label}
          >
            {menuItem?.label}
          </NavLink>
        );
      } else {
        return (
          <NavLink
            // activeClassName='active'
            to={menuPath}
            className={`headerMenu_item ${
              location.pathname.includes(menuItem?.path) || (menuItem?.path === '/analyze' && location?.pathname.includes('chart-builder')) ? 'active' : ''
            }`}
            key={menuItem?.id}
            qa-data={menuItem?.label}
            onClick={ menuItem?.label === 'Analyze' ?  handleNavLinkClick : ()=> null}
          >
            {menuItem?.label}
          </NavLink>
        );
      }
    }
  };

  if (_isEmpty(navigationMenus)) return null;

  if (navigationMenus?.loading && !navigationMenus?.error) {
    return <SummeryLoader size='small' dataSectionCount={4} dataSectionHeight={42} showGrid />;
  }

  if (accountDetails?.loading && !accountDetails?.error) {
    return <SummeryLoader size='small' dataSectionCount={4} dataSectionHeight={42} showGrid />;
  }

  return (
    <div className={`c-headerMenu ${isMobile ? 'forMobile' : ''}`}>
      {_map(
        _orderBy(
          accountDetails?.isNewMenuStructureEnabled ? navigationMenus?.menu : navigationMenus?.userMenu,
          ['position'],
          ['asc']
        ),
        link => getHeaderMenuItem(link)
      )}
    </div>
  );
};

export default HeaderMenuBar;
